import type { WebConnectorConfig } from '@/components/adg4/spiderweb-container/src/spiderweb-types';

export const teamworkGraphAllFramesConnectors: WebConnectorConfig[] = [
	{
		from: 'frame-1-pill-project',
		to: 'frame-1-avatar-blue',
		connectorType: 'dashed',
		color: 'blue600',
	},
	{
		from: 'frame-1-pill-project',
		to: 'frame-1-icon-circle-arrow',
		color: 'blue600',
	},
	{
		from: 'frame-1-icon-jira',
		to: 'frame-1-icon-circle-arrow',
		color: 'neutral500',
	},
	{
		from: 'frame-1-icon-figma',
		to: 'frame-1-icon-circle-arrow',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'blue500',
	},
	{
		from: 'frame-1-avatar-blue',
		to: 'frame-1-agent-left',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'blue500',
	},
	{
		from: 'frame-1-agent-left',
		to: 'frame-1-loom-to-shrink',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'blue500',
	},
	{
		from: 'frame-1-microsoft-teams-to-shrink',
		to: 'frame-1-agent-right',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'blue500',
	},
	{
		from: 'frame-1-agent-right',
		to: 'frame-1-loom-to-shrink',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'blue500',
	},
	{
		from: 'frame-1-avatar-blue',
		to: 'frame-1-icon-squiggle',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'blue600',
	},
	{
		from: 'frame-1-avatar-blue',
		to: 'frame-1-icon-chat',
		connectorShape: 'arced',
		connectorType: 'dashed',
		color: 'blue600',
	},
	{
		from: 'frame-1-avatar-blue',
		to: 'frame-1-icon-figma',
		connectorType: 'dashed',
		color: 'blue600',
	},
	{
		from: 'frame-1-icon-figma',
		to: 'frame-1-icon-people-team',
		color: 'neutral500',
	},
	{
		from: 'frame-1-icon-chat',
		to: 'frame-1-icon-trello',
		connectorShape: 'arced',
		color: 'blue600',
	},
	{
		from: 'frame-1-icon-sharepoint',
		to: 'frame-1-pill-focus-area',
		color: 'neutral500',
	},
	{
		from: 'frame-1-icon-star-talent',
		to: 'frame-1-pill-focus-area',
		color: 'yellow500',
	},
	{
		from: 'frame-1-avatar-green',
		to: 'frame-1-icon-bitbucket',
		connectorType: 'dashed',
		color: 'lime500',
	},
	{
		from: 'frame-1-pill-roadmap',
		to: 'frame-1-icon-lightbulb',
		connectorShape: 'arced',
		connectorType: 'dashed',
		connectorBias: 'negative',
		color: 'purple500',
	},
	{
		from: 'frame-1-icon-bookmark',
		to: 'frame-1-icon-lightbulb',
		color: 'purple500',
	},
	{
		from: 'frame-1-icon-bookmark',
		to: 'frame-1-icon-target',
		color: 'purple500',
	},
	{
		from: 'frame-1-icon-jpd',
		to: 'frame-1-icon-lightbulb',
		connectorShape: 'curvy',
		connectorBias: 'negative',
		color: 'purple500',
	},
	{
		from: 'frame-1-avatar-purple',
		to: 'frame-1-icon-lightbulb',
		connectorType: 'dashed',
		color: 'purple500',
	},
	{
		from: 'frame-1-avatar-purple',
		to: 'frame-1-icon-target',
		connectorShape: 'arced',
		connectorType: 'dashed',
		connectorBias: 'negative',
		color: 'purple500',
	},
	{
		from: 'frame-1-icon-lightning-bolt',
		to: 'frame-1-icon-target',
		color: 'neutral500',
	},
	{
		from: 'frame-1-icon-sharepoint',
		to: 'frame-1-icon-target',
		color: 'neutral500',
	},
	{
		from: 'frame-1-icon-video',
		to: 'frame-1-icon-bookmark',
		color: 'neutral500',
	},
	{
		from: 'frame-1-icon-lightning-bolt',
		to: 'frame-1-icon-bookmark',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'neutral500',
	},
	{
		from: 'frame-1-avatar-yellow',
		to: 'frame-1-icon-lightning-bolt',
		connectorType: 'dashed',
		color: 'yellow300',
	},
	{
		from: 'frame-1-avatar-yellow',
		to: 'frame-1-icon-bell',
		connectorShape: 'arced',
		connectorType: 'dashed',
		connectorBias: 'negative',
		color: 'yellow300',
	},
	{
		from: 'frame-1-avatar-yellow',
		to: 'frame-1-icon-jsm',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'yellow300',
	},
	{
		from: 'frame-1-icon-sharepoint',
		to: 'frame-1-icon-star-talent',
		color: 'yellow500',
	},
	{
		from: 'frame-1-avatar-orange',
		to: 'frame-1-icon-star-talent',
		connectorShape: 'arced',
		connectorType: 'dashed',
		color: 'yellow500',
	},
	{
		from: 'frame-1-icon-dollar',
		to: 'frame-1-avatar-orange',
		connectorShape: 'arced',
		connectorType: 'dashed',
		color: 'yellow500',
	},
	{
		from: 'frame-1-avatar-blue',
		to: 'frame-1-agent-top',
		connectorType: 'dashed',
		color: 'blue600',
	},
	{
		from: 'frame-1-agent-top',
		to: 'frame-1-microsoft-teams-to-shrink',
		connectorType: 'dashed',
		color: 'blue600',
	},
	{
		from: 'frame-1-icon-brackets',
		to: 'frame-1-icon-behind-microsoft-teams',
		color: 'lime500',
	},
	{
		from: 'frame-1-icon-bitbucket',
		to: 'frame-1-icon-rocket',
		color: 'lime500',
	},
	{
		from: 'frame-1-icon-lightning-bolt',
		to: 'frame-1-icon-rocket',
		color: 'neutral500',
	},
	{
		from: 'frame-1-icon-bookmark',
		to: 'frame-1-pill-roadmap',
		color: 'purple500',
	},
	{
		from: 'frame-1-pill-work-item',
		to: 'frame-1-icon-bitbucket',
		connectorShape: 'curvy',
		connectorBias: 'positive',
		color: 'lime500',
	},
	{
		from: 'frame-1-icon-lightning-bolt',
		to: 'frame-1-icon-csm',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'neutral500',
	},
	{
		from: 'frame-1-icon-lightning-bolt',
		to: 'frame-1-icon-video',
		color: 'neutral500',
		connectorShape: 'arced',
		connectorBias: 'negative',
	},
	{
		from: 'frame-1-pill-roadmap',
		to: 'frame-1-icon-video',
		color: 'neutral500',
		connectorShape: 'arced',
		connectorBias: 'positive',
	},
	{
		from: 'frame-1-icon-brackets',
		to: 'frame-1-pill-work-item',
		color: 'lime500',
	},
	{
		from: 'frame-1-icon-behind-microsoft-teams',
		to: 'frame-1-avatar-green',
		connectorShape: 'arced',
		connectorType: 'dashed',
		connectorBias: 'negative',
		color: 'lime500',
	},
	{
		from: 'frame-1-icon-csm',
		to: 'frame-1-avatar-yellow',
		connectorShape: 'arced',
		color: 'neutral500',
	},
	{
		from: 'frame-1-icon-sharepoint',
		to: 'frame-1-avatar-orange',
		connectorShape: 'arced',
		connectorBias: 'negative',
		connectorType: 'dashed',
		color: 'yellow500',
	},
	{
		from: 'frame-1-icon-sharepoint',
		to: 'frame-1-icon-dollar',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'yellow500',
	},
	{
		from: 'frame-1-icon-jsm',
		to: 'frame-1-icon-gdrive',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'yellow300',
	},
	{
		from: 'frame-1-icon-microsoft',
		to: 'frame-1-icon-dollar',
		color: 'yellow500',
	},
	{
		from: 'frame-1-icon-microsoft',
		to: 'frame-1-icon-jpd',
		color: 'purple500',
	},
	{
		from: 'frame-1-microsoft-teams-to-shrink',
		to: 'frame-1-chip-video-tr',
		color: 'blue500',
	},
	{
		from: 'frame-1-prompt-box',
		to: 'frame-1-and-2-bridge',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
		color: 'blue300',
	},
	{
		from: 'frame-1-chip-team-r',
		to: 'frame-1-chip-video-tr',
		connectorShape: 'straight',
		color: 'blue500',
	},

	/* frame 2 */
	{
		to: 'frame-2-dot-left',
		from: 'frame-2-icon-confluence',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},

	{
		from: 'frame-2-icon-confluence',
		to: 'frame-2-dot-top',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},

	{
		from: 'frame-2-icon-confluence',
		to: 'frame-2-icon-hubspot',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},

	{
		from: 'frame-2-icon-hubspot',
		to: 'frame-2-icon-figma',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},

	{
		from: 'frame-2-icon-figma',
		to: 'frame-2-dot-top-right',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},

	/* frame 3 */

	{
		from: 'frame-2-icon-confluence',
		to: 'frame-3-icon-gdrive',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},
	{
		from: 'frame-3-icon-gdrive',
		to: 'frame-3-icon-cursor',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},
	{
		from: 'frame-3-icon-cursor',
		to: 'frame-3-dot-bottom',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},
	{
		to: 'frame-3-dot-left',
		from: 'frame-3-icon-gdrive',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},
	{
		to: 'frame-3-and-5-icon-jira',
		from: 'frame-3-icon-gdrive',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},
	{
		from: 'frame-3-and-5-icon-jira',
		to: 'frame-3-and-5-dot-right-bottom',
		connectorShape: 'curvy',
		isAnimated: true,
		connectorBias: 'positive',
	},

	/* bridge from frame 3 to frame 4 */
	{
		to: 'frame-3-and-5-icon-jira',
		from: 'frame-4-icon-loom',
		connectorShape: 'curvy',
		isAnimated: true,
		connectorBias: 'positive',
	},

	/* frame 4 */
	{
		from: 'frame-4-dot-top',
		to: 'frame-4-icon-canva',
		isAnimated: true,
	},
	{
		from: 'frame-4-dot-right',
		to: 'frame-4-icon-sharepoint',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},
	{
		from: 'frame-4-icon-canva',
		to: 'frame-4-icon-loom',
		isAnimated: true,
	},
	{
		from: 'frame-4-icon-sharepoint',
		to: 'frame-4-icon-loom',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},

	/* bridge from frame 5 to frame 6 */

	{
		from: 'frame-5-behind-figma',
		to: 'frame-6-behind-rectangle-assets',
		connectorShape: 'curvy',
		connectorBias: 'negative',
	},
	{
		from: 'behind-frame-3-and-5-dot-1',
		to: 'behind-frame-3-and-5-dot-2',
		connectorShape: 'curvy',
		isAnimated: true,
		connectorBias: 'negative',
	},

	/* frame 6 */

	{
		to: 'frame-6-dot-offscreen-bottom-left',
		from: 'frame-6-behind-comment',
		connectorShape: 'arced',
		connectorBias: 'positive',
	},
	{
		to: 'frame-6-icon-figma',
		from: 'frame-6-rectangle-comment',
		connectorShape: 'arced',
		connectorBias: 'negative',
	},
	{
		to: 'frame-6-rectangle-avatars',
		from: 'frame-6-behind-in-progress-top',
		connectorShape: 'curvy',
		connectorBias: 'negative',
	},
	{
		to: 'frame-6-icon-figma',
		from: 'frame-6-behind-done-bottom',
		connectorShape: 'arced',
		isAnimated: true,
		connectorBias: 'positive',
	},
	{
		from: 'frame-6-behind-assets-bottom',
		to: 'frame-6-behind-from-assets-to-avatar',
		color: 'blue500',
		connectorShape: 'curvy',
		connectorBias: 'negative',
	},
	{
		from: 'frame-6-behind-assets-top',
		to: 'frame-6-behind-from-assets-to-avatars-rectangle',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},
	{
		from: 'frame-6-behind-comment',
		to: 'frame-6-behind-from-comment-to-avatar',
		connectorShape: 'arced',
		color: 'blue500',
		connectorBias: 'positive',
	},
	{
		to: 'frame-6-behind-in-progress-bottom',
		from: 'frame-6-behind-from-in-progress-to-avatar',
		color: 'blue500',
		connectorShape: 'arced',
		connectorBias: 'positive',
	},
	{
		from: 'frame-6-behind-done-top',
		to: 'frame-6-behind-from-done-to-avatar',
		color: 'blue500',
		connectorShape: 'curvy',
		connectorBias: 'positive',
	},
	/* frame 7 connectors */

	{
		to: 'final-screen-behind-avatar-blue-to-jpd',
		from: 'final-screen-avatar-blue',
		color: 'neutral500',
	},
	{
		to: 'final-screen-behind-squiggle-to-idea',
		from: 'final-screen-icon-squiggle',
		color: 'neutral500',
	},
	{
		from: 'frame-7-icon-bookmark',
		to: 'frame-7-icon-purple-jpd',
		color: 'neutral500',
	},
	{
		from: 'frame-7-avatar-purple',
		to: 'frame-7-icon-purple-jpd',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'neutral500',
	},
	{
		from: 'frame-7-pill-campaign',
		to: 'frame-7-avatar-purple',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'neutral500',
	},
	{
		from: 'frame-7-pill-campaign',
		to: 'frame-7-icon-hubspot',
		connectorShape: 'arced',
		connectorBias: 'negative',
	},
	{
		from: 'frame-7-pill-campaign',
		to: 'frame-7-dot-x-30-y-0',
		connectorShape: 'arced',
		color: 'blue600',
		connectorBias: 'negative',
	},
	{
		from: 'frame-7-avatar-purple',
		to: 'frame-7-pill-idea',
		color: 'neutral500',
	},
	{
		from: 'frame-7-behind-loom',
		to: 'frame-7-icon-csm',
		color: 'blue300',
	},

	{
		from: 'frame-7-icon-behind-confluence',
		to: 'frame-7-icon-csm',
		color: 'neutral500',
	},
	{
		from: 'frame-7-icon-bell',
		to: 'frame-7-avatar-lime-bottom',
		color: 'neutral500',
	},
	{
		from: 'frame-7-icon-rocket',
		to: 'frame-7-icon-bell',
		color: 'neutral500',
	},
	{
		from: 'frame-7-icon-rocket',
		to: 'frame-7-icon-csm',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'yellow400',
	},
	{
		from: 'frame-7-avatar-yellow',
		to: 'frame-7-icon-csm',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'yellow400',
	},
	{
		from: 'frame-7-avatar-yellow',
		to: 'frame-7-icon-jsm',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'neutral500',
	},
	{
		from: 'frame-7-icon-csm',
		to: 'frame-7-icon-jsm',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'neutral500',
	},
	{
		from: 'frame-7-icon-bell',
		to: 'frame-7-icon-jsm',
		color: 'neutral500',
	},
	{
		from: 'frame-7-icon-bitbucket',
		to: 'frame-7-avatar-saffron',
		connectorBias: 'negative',
		connectorShape: 'arced',
		color: 'neutral500',
	},
	{
		from: 'frame-7-icon-bell',
		to: 'frame-7-avatar-saffron',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'blue600',
	},
	{
		from: 'frame-7-avatar-saffron',
		to: 'frame-7-icon-gdrive',
		color: 'blue600',
	},
	{
		from: 'frame-7-icon-target',
		to: 'frame-7-avatar-saffron',
		color: 'blue600',
	},
	{
		from: 'frame-7-pill-release',
		to: 'frame-7-avatar-lime-bottom',
		color: 'neutral500',
	},
	{
		from: 'frame-7-icon-gdrive',
		to: 'frame-7-avatar-lime-bottom',
		color: 'neutral500',
	},
	{
		from: 'frame-7-avatar-lime-top',
		to: 'frame-7-pill-pr',
		color: 'lime500',
	},
	{
		from: 'frame-7-avatar-lime-top',
		to: 'frame-7-icon-rovo-dev',
		color: 'lime500',
	},
	{
		from: 'frame-7-avatar-lime-top',
		to: 'frame-7-icon-bitbucket',
		color: 'lime500',
	},
	{
		from: 'frame-7-dot-x-50-y-0',
		to: 'frame-7-avatar-orange',
		color: 'orange300',
	},
	{
		from: 'frame-7-icon-focus-top',
		to: 'frame-7-avatar-orange',
		color: 'orange300',
	},
	{
		from: 'frame-7-icon-focus-top',
		to: 'frame-7-dot-x-60-y-0',
	},
	{
		from: 'frame-7-icon-focus-top',
		to: 'frame-7-dot-x-65-y-0',
	},
	{
		from: 'frame-7-icon-jira-top',
		to: 'frame-7-avatar-orange',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'orange300',
	},
	{
		from: 'frame-7-pill-goal',
		to: 'frame-7-avatar-orange',
		connectorShape: 'arced',
		connectorBias: 'negative',
		color: 'orange300',
	},
	{
		from: 'frame-7-pill-campaign',
		to: 'frame-7-icon-bookmark',
		color: 'neutral500',
	},
	{
		from: 'frame-7-icon-bookmark',
		to: 'frame-7-icon-jira-top',
		connectorShape: 'arced',
		color: 'neutral500',
	},
	{
		from: 'frame-7-avatar-lime-top',
		to: 'frame-7-icon-focus-top',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'neutral500',
	},
	{
		from: 'frame-7-avatar-lime-top',
		to: 'frame-7-dot-x-80-y-0',
		color: 'lime500',
	},
	{
		from: 'frame-7-icon-behind-confluence',
		to: 'frame-7-avatar-yellow',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'yellow400',
	},
	{
		from: 'frame-7-icon-jsm',
		to: 'frame-7-avatar-lime-bottom',
		connectorShape: 'arced',
		color: 'neutral500',
	},
	{
		from: 'frame-7-dot-x-0-y-90',
		to: 'pill-meeting-notes',
		connectorShape: 'arced',
		connectorBias: 'positive',
		color: 'blue600',
	},
];

export const teamworkGraphMobileConnectorsA: WebConnectorConfig[] = [
	{
		from: 'mobile-component-A-icon-figma-top',
		to: 'mobile-component-A-avatar-blue-top',
		connectorShape: 'arced',
		connectorBias: 'negative',
	},
	{
		from: 'mobile-component-A-hex-wrench-2',
		to: 'mobile-component-A-avatar-blue-top',
	},
	{
		from: 'mobile-component-A-rectangle-prompt',
		to: 'mobile-component-A-avatar-blue-top',
		color: 'blue300',
	},
	{
		from: 'mobile-component-A-hex-wrench-1',
		to: 'mobile-component-A-avatar-blue-top',
	},
	{
		from: 'mobile-component-A-hex-wrench-1',
		to: 'mobile-component-A-rectangle-project',
	},
	{
		from: 'mobile-component-A-icon-microsoft-teams',
		to: 'mobile-component-A-rectangle-project',
	},
	{
		from: 'mobile-component-A-icon-circle-arrow',
		to: 'mobile-component-A-avatar-blue-top',
		connectorShape: 'arced',
		connectorBias: 'negative',
	},
	{
		from: 'mobile-component-A-rectangle-project',
		to: 'mobile-component-A-dot-top-left',
	},
	{
		from: 'mobile-component-A-hex-wrench-2',
		to: 'mobile-component-A-dot-top-right',
		connectorShape: 'arced',
		connectorBias: 'positive',
	},
];

export const teamworkGraphMobileConnectorsB: WebConnectorConfig[] = [
	{
		from: 'mobile-component-B-icon-confluence',
		to: 'mobile-component-B-dot-top',
		color: 'blue300',
	},
	{
		from: 'mobile-component-B-icon-confluence',
		to: 'mobile-component-B-dot-left-bottom',
		color: 'blue300',
		isAnimated: true,
		connectorShape: 'arced',
		connectorBias: 'negative',
	},
	{
		from: 'mobile-component-B-icon-confluence',
		to: 'mobile-component-B-icon-figma-bottom',
		color: 'blue300',
		isAnimated: true,
		connectorShape: 'arced',
		connectorBias: 'positive',
	},
	{
		to: 'mobile-component-B-dot-right-bottom',
		from: 'mobile-component-B-icon-figma-bottom',
		color: 'blue300',
		isAnimated: true,
		connectorShape: 'arced',
		connectorBias: 'positive',
	},
	{
		from: 'mobile-component-B-icon-confluence',
		to: 'mobile-component-B-rectangle-assets',
		color: 'blue300',
		isAnimated: true,
		connectorShape: 'curvy',
		connectorBias: 'positive',
		animationColor: 'blue',
	},
];

export const teamworkGraphMobileConnectorsC: WebConnectorConfig[] = [
	{
		from: 'mobile-component-C-dot-top',
		to: 'mobile-component-C-icon-figma-bottom',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
		animationColor: 'blue',
	},
	{
		from: 'mobile-component-C-dot-top',
		to: 'mobile-component-C-dot-left',
		connectorShape: 'arced',
		connectorBias: 'negative',
	},
];

export const teamworkGraphMobileConnectorsD: WebConnectorConfig[] = [
	{
		from: 'mobile-component-D-dot-top',
		to: 'mobile-component-D-icon-gdrive',
		isAnimated: true,
		connectorShape: 'arced',
		connectorBias: 'positive',
	},
	{
		from: 'mobile-component-D-icon-gdrive',
		to: 'mobile-component-D-dot-right',
		connectorShape: 'arced',
		connectorBias: 'positive',
	},
	{
		from: 'mobile-component-D-dot-top',
		to: 'mobile-component-D-rectangle-in-progress',
		isAnimated: true,
		connectorShape: 'arced',
		connectorBias: 'negative',
	},
];

export const teamworkGraphMobileConnectorsE: WebConnectorConfig[] = [
	{
		from: 'mobile-component-E-dot-top',
		to: 'mobile-component-E-icon-sharepoint-bottom',
		isAnimated: true,
		connectorShape: 'arced',
		connectorBias: 'negative',
	},
	{
		from: 'mobile-component-E-icon-sharepoint-bottom',
		to: 'mobile-component-E-dot-left',
		connectorShape: 'arced',
		isAnimated: true,
		connectorBias: 'negative',
	},
];

export const teamworkGraphMobileConnectorsF: WebConnectorConfig[] = [
	{
		from: 'mobile-component-F-dot-top',
		to: 'mobile-component-F-dot-left',
		isAnimated: true,
		connectorShape: 'arced',
		connectorBias: 'negative',
	},
	{
		from: 'mobile-component-F-dot-top',
		to: 'mobile-component-F-rectangle-comment',
		connectorShape: 'arced',
		isAnimated: true,
		connectorBias: 'negative',
	},
	{
		to: 'mobile-component-F-dot-bottom-right',
		from: 'mobile-component-F-rectangle-comment',
		connectorShape: 'arced',
		isAnimated: true,
		connectorBias: 'positive',
	},
];

export const teamworkGraphMobileConnectorsH: WebConnectorConfig[] = [
	{
		from: 'mobile-component-H-dot-top-left',
		to: 'mobile-component-H-icon-figma',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},
	{
		to: 'mobile-component-H-dot-top-right',
		from: 'mobile-component-H-icon-figma',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},
	{
		from: 'mobile-component-H-dot-top-left',
		to: 'mobile-component-H-icon-microsoft',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},
	{
		to: 'mobile-component-H-dot-middle-left',
		from: 'mobile-component-H-icon-microsoft',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},
	{
		from: 'mobile-component-H-dot-top-left',
		to: 'mobile-component-H-rectangle-avatars',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},
	{
		to: 'mobile-component-H-dot-bottom',
		from: 'mobile-component-H-rectangle-avatars',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},
];

export const teamworkGraphMobileConnectorsI: WebConnectorConfig[] = [
	{
		from: 'mobile-component-I-dot-top',
		to: 'mobile-component-I-dot-mid',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},
	{
		from: 'mobile-component-I-dot-mid',
		to: 'mobile-component-I-avatar-blue',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},
	{
		from: 'mobile-component-I-dot-mid',
		to: 'mobile-component-I-dot-left-mid',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},
	{
		from: 'mobile-component-I-dot-mid',
		to: 'mobile-component-I-dot-right-mid',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},
	{
		from: 'mobile-component-I-avatar-blue',
		to: 'mobile-component-I-dot-left-bottom',
		connectorShape: 'arced',
		connectorBias: 'negative',
		isAnimated: true,
	},
	{
		from: 'mobile-component-I-avatar-blue',
		to: 'mobile-component-I-dot-right-bottom',
		connectorShape: 'arced',
		connectorBias: 'positive',
		isAnimated: true,
	},
];
